(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sidebar-deals"]) return;
  try {
    
 $(document).ready(function(){
     var homeSidedeals = $(".sidebar-deal-products");
      homeSidedeals.owlCarousel({
      items:1,
         loop:true,              
         dots: false,
         navContainer: ".home_sidebar--deal-nav",
         navText: [' <a class="prev active btn"><i class="icon-arrow-left icons"></i></a>','<a class="next btn"><i class="icon-arrow-right icons"></i></a>'],
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items:1
           },
           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-featured-post"]) return;
  try {
    
$(document).ready(function(){
     var homeSidefp = $(".home-sidebar-featured-post__inner");
      homeSidefp.owlCarousel({
      items:1,
      dots: false,  
      autoplay:true,
      smartSpeed : 1000,
      navSpeed : 1000,
         responsive:{
      0:{
      items: 1
      },
      600:{
      items:1
      },
      700:{
      items:1
      },
      1000:{
      items: 1
      }
      }
      });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-featured-products"]) return;
  try {
    
 $(document).ready(function(){
     var homeSidefeatured = $(".sidebar-featured-products");
      homeSidefeatured.owlCarousel({
      items:1,
         loop:true,              
         dots: false,
         navContainer: ".home_sidebar--featured-nav",
         navText: [' <a class="prev active btn"><i class="icon-arrow-left icons"></i></a>','<a class="next btn"><i class="icon-arrow-right icons"></i></a>'],
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items:1
           },
           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-promoimage"]) return;
  try {
    
 $(document).ready(function(){
     var promoimage = $("#promo-carousel");
      promoimage.owlCarousel({
         items:1,
         loop:true,              
         dots: true,       
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items: 1
           },           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-promoimage_2"]) return;
  try {
    
 $(document).ready(function(){
     var promoimage_2 = $("#promo-carousel_2");
      promoimage_2.owlCarousel({
         items:1,
         loop:false,              
         dots: false,  
          autoplay:true,
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items: 1
           },           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();
})();
